export const aboutObjOne = {
    id: 'AboutMe',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    dark: false,
    primary: false,
    darkText: true,
    headLine: 'Qui suis-je?',
    description: `Je me présente Maëva Fortune, 19 ans et originaire de Corrèze. Mon intérêt pour l'informatique me vient du primaire et d'un vieux jeu internet. Je faisais des pages HTML/CSS sur ce site. Plus tard, au collège, après moult et moult recherches pour trouver le meilleur langage de programmation pour débuter, j'ai décidé de suivre un cours de C *Oui* sur Openclassrooms. De là, j'ai su que je voulais travailler dans l'informatique. Maintenant la question, c'est dans quel domaine ? Bon, l'informatique, c'est bien, mais je vous invite à scroller en bas pour en découvrir plus.`,
    imgStart: false,
    img: '/images/about-me.png',
    alt: 'myPicture'

};

export const aboutObjTwo = {
    id: 'Involved',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    dark: true,
    primary: true,
    darkText: false,
    headLine: 'Je suis engagée',
    description: `Dans ma vie, j'ai toujours essayé de m'impliquer dans des projets qui me tiennent à coeur. 
    Par exemple, j'ai participé à des actions contre le cancer du sein, j'ai dansé pour le téléthon 
    pendant plusieurs années, je me suis impliqué entant que bénévole régulière pour la SPA du coin. 
    Arrivé à l'IUT informatique, il me semblait naturel de m'impliquer dans la vie associative étudiante. 
    En 2020, j'ai pu alors devenir trésorière de l'ABEII. Malheureusement le COVID a un peu gâché l'expérience. 
    Cependant, nous avons pu réaliser plusieurs événements. Tel que La Nuit de l'Info 2020 à Bordeaux où 
    j'étais chargée de contacter les entreprises, et un concours de logo pour la création de sweats 
    à l'effigie de l'IUT informatique. `,
    imgStart: true,
    img: '/images/about-involved.svg',
    alt: 'svg picture heart'

};

export const aboutObjThree = {
    id: 'Travel',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    dark: false,
    primary: false,
    darkText: true,
    headLine: "J'aimes voyager",
    description: `J'aime les voyages, les langues et l'histoire. 
    Mon amour du voyage me vient de mon amour pour l'histoire et les cultures, et la connaissance 
    des autres passe aussi par la maîtrise de leurs langues. Je n'ai pas encore eu l'occasion de voyager 
    énormément hors de la France, je suis allée en Angleterre, en Espagne, en Suisse et aux Pays-Bas. 
    Cependant, voyager ce n'est pas qu'en-dehors des frontières. Hormis la Bretagne, je me suis rendu dans toutes 
    les régions de France. Mon plus beau souvenir, 3 jours de camping proche d'un lac, entouré par 
    de beaux paysages du Limousin. Hormis les voyages, j'ai commencé à apprendre le dialecte égyptien. 
    L'Arabe est une langue très utile pour voyager, c'est pour cela qu'il me fallait de l'apprendre sachant 
    que je parle déjà Anglais et Espagnol. `,
    imgStart: false,
    img: '/images/about-travel.svg',
    alt: 'travel'

};

export const aboutObjFour = {
    id: 'Activities',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    dark: true,
    primary: true,
    darkText: false,
    headLine: 'Je suis impliquée',
    description: `À l'instar de mon engagement dans des associations, j'aime m'impliquer dans des projets ou des activités de tout type. À l'école primaire, j'ai chanté dans la chorale de l'école pendant 2 ans.
    Au collège, j'ai continué la chorale, mais cette fois-ci dans un groupe regroupant plusieurs établissements. Je dois avouer que je ne sais pas chanter malgré toutes ces années de chorale. En plus de développer mes incroyables compétences de chant, j'ai été dans la troupe de théâtre du collège pendant 3 ans. Au Lycée, j'ai arrêté les options artistiques pour me tourner vers des options plus scientifiques. En seconde, j'ai intégré la section européenne option sciences de l'ingénieur. Ce choix m'a poussé par la suite à me diriger vers un BAC STI2D option sciences du numériques où j'ai participé aux Mecanodrones et aux Olympiades des Sciences de l'ingénieur. Dans les deux concours, mon équipe et moi avons fini deuxièmes. `,
    buttonLabel: 'Contact',
    imgStart: true,
    img: '/images/about-activities.svg',
    alt: 'activities'

};

//////////////PROJECTS SECTION/////////////////////////

export const aboutLotus = {
    id: 'Lotus',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    dark: false,
    primary: false,
    darkText: true,
    headLine: 'Lotus - application mobile',
    description: ` `,
    buttonLabel: 'Retour',
    imgStart: true,
    img: '/images/LotusScreens.png',
    alt: 'lotus'

};

export const aboutGCSS = {
    id: 'Gcss',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    dark: false,
    primary: false,
    darkText: true,
    headLine: 'GCSS - Site Symfony',
    description: ` `,
    buttonLabel: 'Retour',
    imgStart: true,
    img: '/images/GCSS_Screens.png',
    alt: 'GCSS'

};

export const aboutDisco = {
    id: 'Disco',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    dark: false,
    primary: false,
    darkText: true,
    headLine: 'Emprunt disque - App C#',
    description: ` `,
    buttonLabel: 'Retour',
    imgStart: true,
    img: '/images/Disco_Screens.png',
    alt: 'Disco'

};


